import App from './App'
import render from 'commons/js/util/render'
import { init as initReporter } from 'commons/js/util/reporter'
initReporter()
const selector = '.js-session-janitor'
const element = document.querySelector(selector)
const dataset = element.dataset
const milliseconds = dataset ? parseInt(dataset['milliseconds']) : null
render({ App, element, props: { milliseconds } })
